"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _getDisplayName = require("b2b-components/utils/getDisplayName");
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var _excluded = ["images", "videos"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var withContainer = function withContainer(Component) {
  var WithContainer = function WithContainer(props) {
    var images = props.images,
      videos = props.videos,
      originalProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
    var image360 = originalProps.image360,
      maxThumbnailCount = originalProps.maxThumbnailCount,
      totalImage360Count = originalProps.totalImage360Count,
      totalImageCount = originalProps.totalImageCount,
      totalVideoCount = originalProps.totalVideoCount;
    var previewImages = (0, _react.useMemo)(function () {
      if (!images || !images.length) {
        return null;
      }
      var imageCount = Math.min(maxThumbnailCount, totalImageCount);
      if (totalImage360Count && imageCount === maxThumbnailCount) {
        --imageCount;
      }
      if (totalVideoCount && imageCount + totalImage360Count === maxThumbnailCount) {
        --imageCount;
      }
      return images.slice(0, imageCount);
    }, [images, maxThumbnailCount, totalImageCount, totalImage360Count, totalVideoCount]);
    var previewVideos = (0, _react.useMemo)(function () {
      if (!videos || !videos.length) {
        return null;
      }
      var videosCount = 1;
      if (totalImageCount + totalImage360Count < maxThumbnailCount) {
        videosCount = Math.min(maxThumbnailCount - (totalImageCount + totalImage360Count), videos.length);
      }
      return videos.slice(0, videosCount);
    }, [videos, maxThumbnailCount, totalImageCount, totalImage360Count]);
    var previewItemIndexArray = (0, _react.useMemo)(function () {
      var itemIndexArray = previewImages ? Array.from(Array(previewImages.length).keys()) : [];
      image360 && itemIndexArray.push(totalImageCount);
      previewVideos && Array.from(Array(previewVideos.length).keys()).map(function (index) {
        return itemIndexArray.push(index + totalImageCount + totalImage360Count);
      });
      return itemIndexArray;
    }, [image360, previewImages, previewVideos, totalImageCount, totalImage360Count]);
    var injectedProps = {
      images: previewImages,
      itemIndexArray: previewItemIndexArray,
      videos: previewVideos
    };
    return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, originalProps, injectedProps));
  };
  WithContainer.displayName = "withContainer(".concat((0, _getDisplayName.getDisplayName)(Component), ")");
  (0, _hoistNonReactStatics["default"])(WithContainer, Component);
  return WithContainer;
};
exports.withContainer = withContainer;